import {type MetaFunction} from '@remix-run/node';
import {Container} from '#/app/components/Container.jsx';
import {DiscoverMoreFeatures} from '#/app/components/DiscoverMoreFeatures.jsx';
import {Feature} from '#/app/components/Feature.jsx';
import {Highlight} from '#/app/components/Highlight.jsx';
import {Image} from '#/app/components/Image.jsx';
import {FEATURES} from '#/app/content.js';
import {createMetaHandler} from '#/app/helpers/createMetaHandler.js';
import {createMetaTags} from '#/app/helpers/createMetaTags.js';

const FEATURE_INDEX = 0;
const FEATURE = FEATURES[FEATURE_INDEX];

export const meta: MetaFunction = createMetaHandler(() => {
  return createMetaTags({
    description: FEATURE.meta,
    title: `${FEATURE.tagline} - Ufleet`,
    url: `https://ufleet.io${FEATURE.link}`,
  });
});

const HIGHLIGHTS = [
  {
    description: [
      'Access to unique personalized portal gives customers a peace of mind. They know the location of their package at any time, who will deliver it and when. A call to customer support or the driver is just a click away.',
    ],
    // image: () => (
    //   <div className="relative -left-16 -top-8">
    //     <Image
    //       className="absolute z-20 py-12 bg-white border shadow-xl- top-4 rounded-xl w-80"
    //       src="/features-customer-portal-1-1.png"
    //     />
    //     <Image
    //       className="relative top-0 z-10 py-8 bg-white border shadow-xl- rounded-xl w-80 left-52"
    //       src="/features-customer-portal-1-2.png"
    //     />
    //     <div className="absolute z-20 w-64 px-4 py-2 text-white bg-pink-500 rounded-xl top-64 left-96">
    //       Your order is on its way.
    //       <br />
    //       Track its position in real-time: ufleet.io/t/wia81mx1h
    //     </div>
    //   </div>
    // ),
    image: () => (
      <div className="flex w-10/12 items-center justify-center sm:w-full">
        <Image
          alt="ufleet customer portal screenshot showing scheduled delivery time"
          src="/features-customer-portal-1.png"
          style={{maxWidth: 500}}
        />
      </div>
      // <div className="relative -left-8">
      //   <Image
      //     className="relative top-0 z-10 py-6 bg-white border shadow-xl- rounded-xl w-80 -left-4"
      //     src="/features-customer-portal-1-1.png"
      //   />
      //   <div className="absolute z-20 w-64 px-4 py-2 text-white bg-pink-500 rounded-xl top-32 left-64">
      //     Your order is coming TODAY between 13:00 and 14:00.
      //     <br />
      //     Track it in real-time: ufleet.io/t/wia81mx1h
      //   </div>
      // </div>
    ),
    subtitle: 'Give customers control',
    title: 'Customers track delivery progress in real time',
  },
  {
    description: [
      'Customer portal decreases stress on service centers by reducing inbound calls.',
      'Customers need to call only as last resort. Naturally, they experience reduced wait times and premium service.',
    ],
    image: () => (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="ufleet customer portal screenshot showing details of the delivery agent and a map of his position"
          src="/features-customer-portal-2.png"
          style={{maxWidth: 600}}
        />
      </div>
      // <div className="relative -left-48">
      //   <Image
      //     className="absolute z-20 py-8 bg-white border shadow-xl- top-4 rounded-xl w-80"
      //     src="/features-customer-portal-2-1.png"
      //   />
      //   <Image
      //     className="relative top-0 z-10 py-10 bg-white border shadow-xl- rounded-xl w-80 left-52"
      //     src="/features-customer-portal-2-2.png"
      //   />
      //   <div className="absolute z-20 w-64 px-4 py-2 text-white bg-pink-500 rounded-xl top-56 left-96">
      //     Your order is on its way.
      //     <br />
      //     Track it in real-time: ufleet.io/t/wia81mx1h
      //   </div>
      // </div>
    ),
    subtitle: 'Fewer inbound calls',
    title: 'No more "Where is my package" calls',
  },
  {
    description: [
      'Asking for feedback while impression is still fresh greatly increases response rate and feedback quality.',
      'Taking immediate actions on exception cases leads to higher retention, engagement, and loyalty.',
    ],
    image: () => (
      <div className="flex w-10/12 items-center justify-center sm:w-full">
        <Image
          alt="ufleet customer portal screenshot showing the rating screen"
          src="/features-customer-portal-3.png"
          style={{maxWidth: 500}}
        />
      </div>
      // <div className="relative -left-12">
      //   <Image
      //     className="relative z-10 py-6 bg-white border shadow-xl- rounded-xl w-80"
      //     src="/features-customer-portal-3-1.png"
      //   />
      //   <div className="absolute z-20 w-64 px-4 py-2 text-white bg-pink-500 rounded-xl top-24 left-72">
      //     Thank you for your order! Please take a minute to rate your delivery
      //     experience at ufleet.io/t/wia81mx1h
      //   </div>
      // </div>
    ),
    subtitle: 'Capture customer satisfaction',
    title: 'Get immediate feedback upon delivery',
  },
];

const CustomerPortal = () => {
  return (
    <>
      <Container>
        <Feature feature={{...FEATURE, description: FEATURE.innerDescription, title: FEATURE.innerTitle}} />
        <div className="my-36 space-y-24 sm:space-y-72">
          {HIGHLIGHTS.map((highlight, i) => (
            <Highlight
              feature={FEATURE}
              highlight={highlight}
              i={i}
              key={highlight.title}
            />
          ))}
        </div>
      </Container>
      <DiscoverMoreFeatures skip={FEATURE_INDEX} />
    </>
  );
};

export default CustomerPortal;
